// src/data/programFaqs.js

const programFaqs = [
  {
    slug: "digital-marketing-mentorship-program",
    faqs: [
      {
        faqNumber: 1,
        question: "What are the prerequisites for this course?",
        answer:
          "While there are no formal prerequisites for our Digital Marketing Program, a passion for learning and an interest in Digital Marketing will certainly enhance your experience.",
      },
      {
        faqNumber: 2,
        question: "When do the live group calls and guest sessions take place?",
        answer:
          "The live group calls are scheduled on weekends. The complete program schedule will be shared during the onboarding call.",
      },
      {
        faqNumber: 3,
        question: "What happens if I can't attend the live sessions?",
        answer:
          "We've designed our Digital Marketing Program to accommodate your busy schedule. If you miss a live session, you can catch up with session recordings and participate in community forum discussions at your convenience.",
      },
      {
        faqNumber: 4,
        question: "How involved is the mentor in this program?",
        answer:
          "Our mentor will actively participate during live sessions to answer questions and provide feedback. While we can't promise a response to every single message outside these sessions, the mentor will regularly share insights and address common issues.",
      },
      {
        faqNumber: 5,
        question:
          "How much time should I expect to invest in this program weekly?",
        answer:
          "To get the most out of this program, we recommend spending at least 4-5 hours per week. The live sessions will typically last about an hour, with additional time for exercises, discussions, and personal study.",
      },
      {
        faqNumber: 6,
        question: "What is included in this program?",
        answer:
          "When you join our Digital Marketing, you get lifetime access to all pre-study materials, recordings of live sessions, guest sessions, and an exclusive online community for networking and discussion. Even after the program concludes, you retain indefinite access to all these resources.",
      },
      {
        faqNumber: 7,
        question: "What if I have a question or problem between live sessions?",
        answer:
          "Our program includes access to a vibrant online community where you can post questions, share insights, and learn from your peers. We also provide session recordings for review at your leisure.",
      },
      {
        faqNumber: 8,
        question:
          "Do I need any specific software or hardware for this program?",
        answer:
          "Most of the tools and platforms we'll use during this program are accessible online. Any specific requirements will be communicated to you before the start of the program.",
      },
      {
        faqNumber: 9,
        question: "What kind of certification will I receive upon completion?",
        answer:
          "Upon successful completion of 80% of the coursework, including all learning modules and project submissions, you'll receive a Certificate of Completion from our organization, recognizing your new skills and knowledge.",
      },
      {
        faqNumber: 10,
        question:
          "What opportunities are available after completing this program?",
        answer:
          "This program is designed to provide practical skills and knowledge in Digital Marketing, making you more attractive to employers in a range of industries. Additionally, you'll join a network of like-minded individuals for potential collaboration and learning opportunities.",
      },
    ],
  },
  {
    slug: "performance-marketing-mentorship-program",
    faqs: [
      {
        faqNumber: 1,
        question: "What is this program about?",
        answer:
          "This program will help you KICKSTART your performance marketing journey. It will help you understand the nitty-gritty involved in performance marketing. Understand each component deeply. This program is designed to get you industry-ready in 8 weeks + 2 weeks. With interview preparation and live access to the community.",
      },
      {
        faqNumber: 2,
        question: "Is this a completely live program?",
        answer:
          "No. This is a hybrid of on-demand content and live sessions. Every week you will get access to on-demand content. And you can get all your doubts and queries answered in the QnA sessions.",
      },
      {
        faqNumber: 3,
        question: "Are there any prerequisites for this program?",
        answer:
          "1-to 2 years of experience in the marketing field is what we are looking at here + a willingness to provide time towards learning and exploring this high reward field.",
      },
      {
        faqNumber: 4,
        question: "What if I can’t make the live sessions?",
        answer:
          "The program is designed to work with your schedule. Although we highly encourage you to attend the live sessions it’s not a problem if you can’t. You’re able to watch the session recordings and participate in discussions and feedback on the community forum.",
      },
      {
        faqNumber: 5,
        question: "How much access do I have of the mentors?",
        answer:
          "You’ll have complete access to Deepan and Vipins’s recorded content. And you’ll have weekly live sessions with the Program Director! You will also be part of the community with the Mentor and they will try and solve your queries as soon as possible. They will answer questions, provide feedback, and share his private notes to address common pain points.",
      },
      {
        faqNumber: 6,
        question: "What deliverables will I walk away with?",
        answer:
          "This program is all about upskilling, taking action, and getting industry-ready. In the first 10 weeks of the program, you’ll learn all the important components of performance marketing including; fundamentals of performance marketing, creating copies that convert, creating value prop, advanced conversion tracking, understanding google and Facebook ads, media buying, and planning, understanding attribution and automation. Once you complete your 10 weeks of upskilling, you’ll be guided on how to go about finding opportunities. From resume preparation to interview preparation, this program will help you become industry-ready.",
      },
    ],
  },
  {
    slug: "ui-ux-design-mentorship-program",
    faqs: [
      {
        faqNumber: 1,
        question: "Are there any prerequisites for this program?",
        answer:
          "This program does not have any formal prerequisites. Just bring yourself and your hunger to learn!",
      },
      {
        faqNumber: 2,
        question:
          "When do the Live Mentor Sessions & Practice Sessions happens?",
        answer:
          "Live sessions will happen every weekend. You will be informed about the exact schedule and timing of the sessions before the program starts, so you can plan your weekends accordingly!",
      },
      {
        faqNumber: 3,
        question: "What if I can't make the live sessions?",
        answer:
          "We've designed this program keeping your busy schedules in mind, so making it to LIVE sessions should not pose a challenge. These sessions are your chance to clear any doubts, ask personal questions and bond with your fellow cohort members. However, if you do end up missing the LIVE session, we can provide you with recordings of the same.",
      },
      {
        faqNumber: 4,
        question: "How much access do I get to the mentors?",
        answer:
          "The live sessions make sure you're in constant touch with the mentors to clear doubts, get feedback or ask your personal questions, so make sure to attend them!",
      },
      {
        faqNumber: 5,
        question:
          "How much time can I expect to spend on the program each week?",
        answer:
          "At least 4-5 hours per week, for the 16 weeks of the program. This program is a sprint, and you’ll be asked to execute things as well. The live sessions will be 90 minutes long. We also offer bonus Guest workshops and Jamming Sessions throughout the program.",
      },
      {
        faqNumber: 6,
        question: "What's include within the program?",
        answer:
          "With this program, you’ll have lifetime access to all the study material, recordings of the live sessions, access to an exclusive online community where you can interact with your cohort members, and priority invites to our offline events.",
      },
    ],
  },
  {
    slug: "product-management-mentorship-program",
    faqs: [
      {
        faqNumber: 1,
        question: "Who is this program for?",
        answer:
          "The product manager role doesn't require any core technical skills hence people coming from any profession like Sales, Marketing, Software Engineers/Developers/QAs, Analysts (Data/Business), Ops, Customer Support/Success and many others already possess some foundational soft skills that are transferable for a product manager role.",
      },
      {
        faqNumber: 2,
        question: "What is the application process?",
        answer:
          "This exclusive program is open to only 60 serious candidates. Our qualification process mirrors a typical hiring process: - Start with an application form to assess background and intent. - Complete the form to be scheduled for a qualifier interview, evaluating your career journey and how we can accelerate it. - Pass the interview by demonstrating proactive seriousness about the transition. - Limited scholarships available for those affected by layoffs.",
      },
      {
        faqNumber: 3,
        question: "How much access do I get to the mentors?",
        answer:
          "All mentors are active during the live sessions and can answer any doubts/queries you raise then. You can also approach them for feedback during both group and guest sessions.",
      },
      {
        faqNumber: 4,
        question:
          "How much time can I expect to spend on the program each week?",
        answer:
          "At least 8-10 hours per week, for the 14 weeks of the program. This frequency will help you get to your goal in the stipulated time.",
      },
      {
        faqNumber: 5,
        question: "What’s included with the program?",
        answer:
          "Along with your content, you’ll have lifetime access to all the pre-study material, recordings of the live cohort sessions, guest sessions, and a private online community where you can interact with your batchmates. You’ll retain access to the program materials and community indefinitely after the program ends.",
      },
      {
        faqNumber: 6,
        question: "Who are your placement partners?",
        answer:
          "We have a healthy blend of 60% of hiring managers and recruiters database and 40% of third party recruitment agencies who have companies from Fortune 500, Unicorn Startups and FAANG under their portfolio. But we believe our community and mentor network is very strong and will enable you with referrals if performed and networked well through the program.",
      },
      {
        faqNumber: 7,
        question: "When will I get my GrowthSchool Certificate?",
        answer:
          "Individuals who successfully complete their 80% course work i.e. cover all learning modules & project submissions, are eligible to receive a Certificate of Completion from GrowthSchool which acts as a seal of trust for your proof of work under the guidance of industry leaders.",
      },
    ],
  },
  {
    slug: "management-consulting-mentorship-program",
    faqs: [
      {
        faqNumber: 1,
        question: "What is this program about?",
        answer:
          "This program will help you KICKSTART your performance marketing journey. It will help you understand the nitty-gritty involved in performance marketing. Understand each component deeply. This program is designed to get you industry-ready in 8 weeks + 2 weeks. With interview preparation and live access to the community.",
      },
      {
        faqNumber: 2,
        question: "Is this a completely live program?",
        answer:
          "No. This is a hybrid of on-demand content and live sessions. Every week you will get access to on-demand content. And you can get all your doubts and queries answered in the QnA sessions.",
      },
      {
        faqNumber: 3,
        question: "Are there any prerequisites for this program?",
        answer:
          "1-to 2 years of experience in the marketing field is what we are looking at here + a willingness to provide time towards learning and exploring this high reward field.",
      },
      {
        faqNumber: 4,
        question: "What if I can’t make the live sessions?",
        answer:
          "The program is designed to work with your schedule. Although we highly encourage you to attend the live sessions it’s not a problem if you can’t. You’re able to watch the session recordings and participate in discussions and feedback on the community forum.",
      },
      {
        faqNumber: 5,
        question: "How much access do I have of the mentors?",
        answer:
          "You’ll have complete access to Deepan and Vipins’s recorded content. And you’ll have weekly live sessions with the Program Director! You will also be part of the community with the Mentor and they will try and solve your queries as soon as possible. They will answer questions, provide feedback, and share his private notes to address common pain points.",
      },
      {
        faqNumber: 6,
        question: "What deliverables will I walk away with?",
        answer:
          "This program is all about upskilling, taking action, and getting industry-ready. In the first 10 weeks of the program, you’ll learn all the important components of performance marketing including; fundamentals of performance marketing, creating copies that convert, creating value prop, advanced conversion tracking, understanding google and Facebook ads, media buying, and planning, understanding attribution and automation. Once you complete your 10 weeks of upskilling, you’ll be guided on how to go about finding opportunities. From resume preparation to interview preparation, this program will help you become industry-ready.",
      },
    ],
  },
  {
    slug: "product-marketing-mentorship-program",
    faqs: [
      {
        faqNumber: 1,
        question: "What is this program about?",
        answer:
          "This program will help you kickstart or scale up your Product Marketing journey. It will help you get a better understanding of Product Marketing, important skills involved in product marketing, demand generation, and more for product-based organizations.",
      },
      {
        faqNumber: 2,
        question: "Why should I take this program now?",
        answer:
          "The product Marketing domain is growing at a faster pace than we can comprehend. The best time to get into Product Marketing was a 5-years back and the next best time is NOW! Working in Marketing is thrilling but working in Product Marketing is even more exciting.",
      },
      {
        faqNumber: 3,
        question: "What if I can’t make the live sessions?",
        answer:
          "The program is designed to work with your schedule. Although we highly encourage you to attend the live sessions it’s not a problem if you can’t.You’re able to watch the session recordings and participate in discussions and feedback on the community forum.",
      },
      {
        faqNumber: 4,
        question: "How much access do I have of the mentors?",
        answer:
          "You’ll have complete access to Deepan and Vipins’s recorded content. And you’ll have weekly live sessions with the Program Director!You will also be part of the community with the Mentor and they will try and solve your queries as soon as possible. They will answer questions, provide feedback, and share his private notes to address common pain points.",
      },
      {
        faqNumber: 5,
        question: "What deliverables will I walk away with?",
        answer:
          "This program is all about upskilling, taking action, and getting industry-ready. In the first 10 weeks of the program, you’ll learn all the important components of performance marketing including; fundamentals of performance marketing, creating copies that convert, creating value prop, advanced conversion tracking, understanding google and Facebook ads, media buying, and planning, understanding attribution and automation. Once you complete your 10 weeks of upskilling, you’ll be guided on how to go about finding opportunities. From resume preparation to interview preparation, this program will help you become industry-ready.",
      },
    ],
  },
  {
    slug: "workshops/linkedin-growth",
    faqs: [
      {
        faqNumber: 1,
        question: "When does the workshop start?",
        answer:
          "The date and timings of the workshop has been mentioned on the top of the page.",
      },
      {
        faqNumber: 2,
        question: "Will this be live or pre-recorded?",
        answer:
          "A mix of both. Every day (all 5 Days) you’ll get the session pre-recorded videos. 2 days there’ll be interactive sessions. One taught by Vaibhav which will be a 2.5 hour long Mega Webinar where you'll learn advanced LinkedIn growth hacks and tactics for which you won't receive any recordings. The other session will be taken live by his team which will be a QnA to answer and clarify all your doubts and queries at the end of the workshop.",
      },
      {
        faqNumber: 3,
        question: "What are the timings?",
        answer:
          "Like mentioned above. Every day you will get the recorded videos at 10PM and you can watch any time of the day. Live sessions would be at 11 AM IST.",
      },
      {
        faqNumber: 4,
        question:
          "I have a full time job, not sure if I can make it. Will you be sharing recordings?",
        answer:
          "Yes! You’ll receive recordings of 5 day classes. Please note, there would be no recording of the live sessions.",
      },
      {
        faqNumber: 5,
        question:
          "Is this workshop an advanced LinkedIn growth hacking program?",
        answer:
          "It’s not a super advanced workshop. It’s for people getting started and streamlining their LinkedIn efforts. You won’t be taught any crazy growth hacking or advanced automation.",
      },
      {
        faqNumber: 6,
        question: "Would there be any certificate on completion?",
        answer: "Yes! You will receive a certificate on completion.",
      },
      {
        faqNumber: 7,
        question: "Will I be able to make a lot of money after this workshop?",
        answer:
          "No program ‘guarantees’ any income, including this. The workshop is designed to get your LinkedIn efforts streamlined and help you get started with generating leads, building a personal brand, or get good job opportunities.",
      },
      {
        faqNumber: 8,
        question: "Do you have an affiliate program?",
        answer:
          "Yes! we do, but it's only open for participants of the workshop.",
      },
      {
        faqNumber: 9,
        question: "I made the payment but didn’t receive any email.",
        answer:
          "Please write to: hi@growthschool.io and our awesome support team will get back to you within 12 hours.",
      },
      {
        faqNumber: 10,
        question: "When can I receive the bonus?",
        answer: "You will get access to all the bonuses during live sessions.",
      },
      {
        faqNumber: 11,
        question: "Will I get a recording of all the sessions?",
        answer:
          "The sessions are time gated for consumption and are the essence of the GrowthSchool Experience. Hence we won’t be providing recordings for the sessions. The idea is to remove procrastination completely and make you take action and completely watch the session & make the most out of it.",
      },
      {
        faqNumber: 12,
        question: "Why is the price of the program so less?",
        answer:
          "We built this GrowthSchool Experience to make it accessible to hundreds and thousands of people at scale. To make that happen we had to solve this one big problem: Mentor’s availability and time. Your mentors quite literally are in the top 1% of their industry which means their time is expensive as well as inadequate. The cost of running the programs instantly goes up if they keep teaching the same thing again and again. That’s exactly why the GrowthSchool Experience is a perfect blend of both worlds. You get to learn from your favourite mentor with like-minded people in a stream at a cost of less than a pizza :)",
      },
      {
        faqNumber: 13,
        question: "Is this a live session?",
        answer:
          "No, it’s better! :) Here’s why: This is an interactive GrowthSchool experience in which you will be learning practical concepts taught by your mentor. You will be attending this stream with like-minded doers like you, while participating in polls, answering thought-provoking questions, attempting quizzes, and doing many more exciting activities. By the end of the value-packed session, you will have a roadmap to reach your desired outcomes.",
      },
      {
        faqNumber: 14,
        question: "Can I record the session for personal use later?",
        answer:
          "The content is owned by GrowthSchool. It is not allowed to record and use it for personal use. Doing so will lead to legal repercussions. But here’s what you should do 😛 Our best learners usually take notes or create mind maps and share them with the community. So, if you want to revisit your learnings or see what was in the content of the session, just take notes and revisit them in the future. Not only does it increase learning output also makes the overall learning experience much much better. Don’t believe it? Just try it :)",
      },
      {
        faqNumber: 15,
        question: "Why can't I watch it anytime I want?",
        answer:
          "Ask yourselves this simple question: How many online courses have you taken up to date? Out of them, how many did you actually complete? Based on all our learnings and surveys in our community, the completion rate lies between 2-3%. Over multiple experiments and ideation, we figured out that giving people access to content is not enough. Making people consume and finish the session is the most important thing. It is of no use if you just register for sessions and never watch them. But with our tech, we are providing a rich interaction-led experience with polls, quizzes, and chats which have helped us increase completion rates of learners go from 2-3% to hit 90%. We believe in our community of doers, that’s what we take pride in. Hence, you can’t watch it anytime you want. You have to make up time, commit and complete it within that timeframe to reach your desired outcomes :)",
      },
      {
        faqNumber: 16,
        question: "Can I ask my questions to the mentor in the session?",
        answer:
          "There will be a dedicated session only for QnAs with your mentors where you can ask all your doubts/questions to the mentor in real-time and interact with him/her.",
      },
      {
        faqNumber: 17,
        question: "If I miss this can I join the next one?",
        answer:
          "Yes, of course, you can! But you’ll have to register and pay for it again when it is scheduled to happen next. That’s exactly why we mention the date and time of the sessions clearly on the landing page and also send multiple reminders on WhatsApp and email so that you don’t miss out on joining the session.",
      },
    ],
  },
  {
    slug: "workshops/chatgpt-workshop",
    faqs: [
      {
        faqNumber: 1,
        question: "When does the workshop start?",
        answer:
          "The date and timings of the workshop has been mentioned on the top of the page.",
      },
      {
        faqNumber: 2,
        question: "Will this be live or pre-recorded?",
        answer:
          "A mix of both. Every day (all 5 Days) you’ll get the session pre-recorded videos. 2 days there’ll be interactive sessions. One taught by Vaibhav which will be a 2.5 hour long Mega Webinar where you'll learn advanced LinkedIn growth hacks and tactics for which you won't receive any recordings. The other session will be taken live by his team which will be a QnA to answer and clarify all your doubts and queries at the end of the workshop.",
      },
      {
        faqNumber: 3,
        question: "What are the timings?",
        answer:
          "Like mentioned above. Every day you will get the recorded videos at 10PM and you can watch any time of the day. Live sessions would be at 11 AM IST.",
      },
      {
        faqNumber: 5,
        question:
          "I have a full time job, not sure if I can make it. Will you be sharing recordings?",
        answer:
          "Yes! You’ll receive recordings of 5 day classes. Please note, there would be no recording of the live sessions.",
      },
      {
        faqNumber: 6,
        question:
          "Is this workshop an advanced LinkedIn growth hacking program?",
        answer:
          "It’s not a super advanced workshop. It’s for people getting started and streamlining their LinkedIn efforts. You won’t be taught any crazy growth hacking or advanced automation.",
      },
      {
        faqNumber: 7,
        question: "Would there be any certificate on completion?",
        answer: "Yes! You will receive a certificate on completion.",
      },
      {
        faqNumber: 10,
        question: "Will I be able to make a lot of money after this workshop?",
        answer:
          "No program ‘guarantees’ any income, including this. The workshop is designed to get your LinkedIn efforts streamlined and help you get started with generating leads, building a personal brand, or get good job opportunities.",
      },
      {
        faqNumber: 11,
        question: "Do you have an affiliate program?",
        answer:
          "Yes! we do, but it's only open for participants of the workshop.",
      },
      {
        faqNumber: 12,
        question: "I made the payment but didn’t receive any email.",
        answer:
          "Please write to: hi@growthschool.io and our awesome support team will get back to you within 12 hours.",
      },
      {
        faqNumber: 13,
        question: "When can I receive the bonus?",
        answer: "You will get access to all the bonuses during live sessions.",
      },
      {
        faqNumber: 14,
        question: "Will I get a recording of all the sessions?",
        answer:
          "The sessions are time gated for consumption and are the essence of the GrowthSchool Experience. Hence we won’t be providing recordings for the sessions. The idea is to remove procrastination completely and make you take action and completely watch the session & make the most out of it.",
      },
      {
        faqNumber: 15,
        question: "Why is the price of the program so less?",
        answer:
          "We built this GrowthSchool Experience to make it accessible to hundreds and thousands of people at scale. To make that happen we had to solve this one big problem: Mentor’s availability and time. Your mentors quite literally are in the top 1% of their industry which means their time is expensive as well as inadequate. The cost of running the programs instantly goes up if they keep teaching the same thing again and again. That’s exactly why the GrowthSchool Experience is a perfect blend of both worlds. You get to learn from your favourite mentor with like-minded people in a stream at a cost of less than a pizza :)",
      },
      {
        faqNumber: 16,
        question: "Is this a live session?",
        answer:
          "No, it’s better! :) Here’s why: This is an interactive GrowthSchool experience in which you will be learning practical concepts taught by your mentor. You will be attending this stream with like-minded doers like you, while participating in polls, answering thought-provoking questions, attempting quizzes, and doing many more exciting activities. By the end of the value-packed session, you will have a roadmap to reach your desired outcomes.",
      },
      {
        faqNumber: 17,
        question: "Can I record the session for personal use later?",
        answer:
          "The content is owned by GrowthSchool. It is not allowed to record and use it for personal use. Doing so will lead to legal repercussions. But here’s what you should do 😛 Our best learners usually take notes or create mind maps and share them with the community. So, if you want to revisit your learnings or see what was in the content of the session, just take notes and revisit them in the future. Not only does it increase learning output also makes the overall learning experience much much better. Don’t believe it? Just try it :)",
      },
      {
        faqNumber: 18,
        question: "Why can't I watch it anytime I want?",
        answer:
          "Ask yourselves this simple question: How many online courses have you taken up to date? Out of them, how many did you actually complete? Based on all our learnings and surveys in our community, the completion rate lies between 2-3%. Over multiple experiments and ideation, we figured out that giving people access to content is not enough. Making people consume and finish the session is the most important thing. It is of no use if you just register for sessions and never watch them. But with our tech, we are providing a rich interaction-led experience with polls, quizzes, and chats which have helped us increase completion rates of learners go from 2-3% to hit 90%. We believe in our community of doers, that’s what we take pride in. Hence, you can’t watch it anytime you want. You have to make up time, commit and complete it within that timeframe to reach your desired outcomes :)",
      },
      {
        faqNumber: 19,
        question: "Can I ask my questions to the mentor in the session?",
        answer:
          "There will be a dedicated session only for QnAs with your mentors where you can ask all your doubts/questions to the mentor in real-time and interact with him/her.",
      },
      {
        faqNumber: 20,
        question: "If I miss this can I join the next one?",
        answer:
          "Yes, of course, you can! But you’ll have to register and pay for it again when it is scheduled to happen next. That’s exactly why we mention the date and time of the sessions clearly on the landing page and also send multiple reminders on WhatsApp and email so that you don’t miss out on joining the session.",
      },
    ],
  },
  {
    slug: "workshops/ai-for-consultants",
    faqs: [
      {
        faqNumber: 1,
        question: "What is ChatGPT, and how can it benefit my business?",
        answer:
          "ChatGPT is an AI language model that can automate tasks, improve efficiency, and enhance customer engagement.",
      },
      {
        faqNumber: 2,
        question:
          "Can I expect hands-on training and practical examples during the workshop?",
        answer:
          "Yes, the workshop includes hands-on training with practical examples.",
      },
      {
        faqNumber: 3,
        question:
          "How can ChatGPT help me save time and resources in my business operations?",
        answer:
          "ChatGPT saves time and resources by automating content creation, customer support, and data analysis.",
      },
      {
        faqNumber: 4,
        question:
          "What kind of support and resources will be available to me after the workshop?",
        answer:
          "Post-workshop support includes access to resources, community forums, and email support.",
      },
      {
        faqNumber: 5,
        question:
          "How can I stay updated on future developments, workshops, and courses related to ChatGPT?",
        answer:
          "Stay updated through our newsletter, website, and social media channels.",
      },
      {
        faqNumber: 6,
        question: "When does the workshop start?",
        answer:
          "You can find all the details regarding the workshop dates and timings on the top of the page.",
      },
      {
        faqNumber: 7,
        question: "Who should attend this workshop?",
        answer:
          "This workshop is designed for professionals of all levels and industries who want to harness the power of AI and ChatGPT to enhance their professional skills and success.",
      },
      {
        faqNumber: 8,
        question: "What are the timings?",
        answer:
          "You can get all the details related to the timings and dates of the workshop on the top of the page.",
      },
      {
        faqNumber: 9,
        question:
          "I have a full time job, not sure if I can make it. Will you be sharing recordings?",
        answer:
          "The workshop is live over the weekend, so your work will not be hampered. But the sessions will not be recorded.",
      },
      {
        faqNumber: 10,
        question: "Would there be any certificate on completion?",
        answer:
          "Yes! You will receive a certificate on completion if you attend the entire live session.",
      },
      {
        faqNumber: 11,
        question: "Do you have an affiliate program?",
        answer: "As of now, we don’t.",
      },
      {
        faqNumber: 12,
        question: "Can I download the videos?",
        answer: "No, you can only attend them live.",
      },
      {
        faqNumber: 13,
        question: "I made the payment but didn’t receive any email.",
        answer:
          "Please write to hi@growthschool.io and our awesome support team will get back to you in under 6 hours.",
      },
      {
        faqNumber: 14,
        question: "When can I receive the bonus?",
        answer:
          "You will receive all the bonuses within 48 hours once the workshop is done.",
      },
      {
        faqNumber: 15,
        question: "What is the time zone?",
        answer: "It is IST (Indian Standard Time).",
      },
    ],
  },
  {
    slug: "workshops/product-management",
    faqs: [
      {
        faqNumber: 1,
        question: "When does the workshop start and what are the timings?",
        answer:
          "You can get all the details related to the timings and dates of the workshop at the top of the page.",
      },
      {
        faqNumber: 2,
        question: "Will it be a live workshop?",
        answer:
          "No, this is not a live session but even better than that! Here’s why :This is an Interactive GrowthSchool experience in which you will be learning practical concepts taught by your mentor. You will be attending this stream with like-minded doers like you, while participating in polls, answering thought-provoking questions, attempting quizzes, and doing many more exciting activities.By the end of the value-packed session, you will have a roadmap to reach your desired outcomes",
      },
      {
        faqNumber: 3,
        question:
          "I made the payment but didn't receive any confirmation email.",
        answer:
          "Write to hi@growthschool.io and our awesome support team will solve your queries in the fastest time possible.",
      },
      {
        faqNumber: 4,
        question: "Will I get the recording ?",
        answer:
          "Yes, you get the recording only if you purchase it. Make sure to purchase it while completing the payment on the next page.",
      },
      {
        faqNumber: 5,
        question: "Can I get a refund?",
        answer:
          "No. We don't provide refunds in any case. If you are not sure about the workshop, check out the testimonials, read more about the trainer and take an informed decision. In case you miss out on attending the live workshop, we can move you to the next batch only ONCE.",
      },
      {
        faqNumber: 6,
        question: "When can I receive the bonuses?",
        answer:
          "After the workshop is done, you will receive all the bonuses within 48 hours.",
      },
      {
        faqNumber: 7,
        question: "Will I get a certificate after completion?",
        answer:
          "Yes, you will receive a certificate of completion if you finish the entire workshop.",
      },
    ],
  },
  {
    slug: "workshops/business-mastermind",
    faqs: [
      {
        faqNumber: 1,
        question: "When is the Business Mastermind?",
        answer:
          "The event kicks off with a mandatory call on Friday at 7PM IST, followed by mastermind sessions on Saturday and Sunday from 11AM to 7PM IST. You can reach out to hi@growthschool.io for exact dates!",
      },
      {
        faqNumber: 2,
        question: "How will the mastermind sessions be conducted?",
        answer:
          "The sessions will be conducted live online with interactive workshops, hands-on exercises, and real-time feedback from our AI marketing experts. You'll also have opportunities for networking and Q&A.",
      },
      {
        faqNumber: 3,
        question: "Is the event completely online?",
        answer:
          "Yes, the entire mastermind is conducted online, making it accessible from anywhere in the world. All you need is a reliable internet connection and a laptop/computer.",
      },
      {
        faqNumber: 4,
        question: "Why can't I receive a recording of the sessions?",
        answer:
          "The mastermind is designed as a live, interactive experience with hands-on exercises and real-time feedback. Recordings can't capture the collaborative atmosphere and personalized guidance that makes this program effective.",
      },
      {
        faqNumber: 5,
        question: "What happens if I can't attend on the scheduled dates?",
        answer:
          "We recommend attending all sessions live for the best experience. However, if you can't make it, please reach out to our team before registering, and we can discuss options for the next cohort.",
      },
      {
        faqNumber: 6,
        question: "Is there any preparation needed before the event?",
        answer:
          "No special preparation is required. Just come with an open mind and a laptop. We'll provide all necessary resources and guidance during the sessions.",
      },
      {
        faqNumber: 7,
        question: "Can I participate if I'm new to Generative AI?",
        answer:
          "Absolutely! The program is designed for all skill levels, including complete beginners. We'll start with the fundamentals and gradually move to more advanced concepts.",
      },
    ],
  },
  {
    slug: "workshops/marketing-mastermind",
    faqs: [
      {
        faqNumber: 1,
        question: "When is the Marketing Mastermind?",
        answer:
          "The event kicks off with a mandatory call on Friday at 7PM IST, followed by mastermind sessions on Saturday and Sunday from 11AM to 7PM IST. You can reach out to hi@growthschool.io for exact dates!",
      },
      {
        faqNumber: 2,
        question: "How will the mastermind sessions be conducted?",
        answer:
          "The sessions will be conducted live online with interactive workshops, hands-on exercises, and real-time feedback from our AI marketing experts. You'll also have opportunities for networking and Q&A.",
      },
      {
        faqNumber: 3,
        question: "Is the event completely online?",
        answer:
          "Yes, the entire mastermind is conducted online, making it accessible from anywhere in the world. All you need is a reliable internet connection and a laptop/computer.",
      },
      {
        faqNumber: 4,
        question: "Why can't I receive a recording of the sessions?",
        answer:
          "The mastermind is designed as a live, interactive experience with hands-on exercises and real-time feedback. Recordings can't capture the collaborative atmosphere and personalized guidance that makes this program effective.",
      },
      {
        faqNumber: 5,
        question: "What happens if I can't attend on the scheduled dates?",
        answer:
          "We recommend attending all sessions live for the best experience. However, if you can't make it, please reach out to our team before registering, and we can discuss options for the next cohort.",
      },
      {
        faqNumber: 6,
        question: "Is there any preparation needed before the event?",
        answer:
          "No special preparation is required. Just come with an open mind and a laptop. We'll provide all necessary resources and guidance during the sessions.",
      },
      {
        faqNumber: 7,
        question: "Can I participate if I'm new to Generative AI?",
        answer:
          "Absolutely! The program is designed for all skill levels, including complete beginners. We'll start with the fundamentals and gradually move to more advanced concepts.",
      },
    ],
  },
];

export default programFaqs;
